import { getMod, useReduxSelector } from 'services/hooks';
import { UNIVERSITY } from 'constants/education';

import { EducationModal, EducationPage } from '../../education.typing';
import {
  getFirstUniversityLevel,
  checkPrerequisites,
} from './education-level.utils';
import { IEducationLevelProps } from './education-level.typing';

export const useEducationLevel = (props: IEducationLevelProps) => {
  const { level, setLevel, setModal, setPage } = props;

  const isEducationRestricted =
    getMod('gamifiedEducation')?.hooks.useEducationRestricted() ?? false;

  const educations = useReduxSelector((redux) => redux.player.educations);
  const educationLevels = useReduxSelector(
    (redux) => redux.app.educationLevels
  );

  const isEducationTutorialPassed = useReduxSelector(
    (redux) =>
      // if tips are disabled
      !Boolean(redux.app.gameMods?.popupTips) ||
      // if tutorial is passed
      Boolean(redux.player.tutorials?.education) ||
      // if gamified education is restricted
      isEducationRestricted
  );

  const isGamifiedEducation = useReduxSelector((redux) =>
    Boolean(redux.app.gameMods?.gamifiedEducation)
  );

  const resultLevel =
    level === UNIVERSITY ? getFirstUniversityLevel(educationLevels) : level;

  const isOpen = (prerequisites?: IPrerequisites[]) => {
    // Always open for gamified education
    if (isGamifiedEducation) {
      return true;
    }

    // Check prerequisites for standard education
    return (
      !!prerequisites &&
      (!prerequisites.length ||
        prerequisites.some(checkPrerequisites(educations)))
    );
  };

  const isComplete = !!educations?.filter((ed) => ed.level === resultLevel)
    .length;

  const onClick = (prerequisites?: IPrerequisites[]) => () => {
    if (!resultLevel || !isEducationTutorialPassed) {
      return;
    }

    if (!isOpen(prerequisites)) {
      return setModal(EducationModal.WrongLevel);
    }

    setLevel(resultLevel);

    if (!educationLevels[resultLevel].isSector) {
      return setModal(EducationModal.StartTest);
    }

    setPage(EducationPage.Sector);
  };

  return {
    isComplete,

    isOpen,
    onClick,
  };
};
